"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doc = document;
exports.root = exports.doc.documentElement || exports.doc;
exports.likelyWireless = 'orientation' in window;
